import { BrowserModule, HAMMER_GESTURE_CONFIG, HammerGestureConfig } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { AppRoutingModule } from 'app-routing.module';
import { MatButtonModule} from '@angular/material/button';
import { MatCheckboxModule} from '@angular/material/checkbox';
import { MatDialogModule} from '@angular/material/dialog';
import { MatDividerModule} from '@angular/material/divider';
import { MatFormFieldModule} from '@angular/material/form-field';
import { MatIconModule} from '@angular/material/icon';
import { MatInputModule} from '@angular/material/input';
import { MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { MatSelectModule} from '@angular/material/select';
import { DatePipe } from '@angular/common';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AllGatesComponent } from './components/all-gates/all-gates.component';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PrivacycomponentComponent } from './components/privacycomponent/privacycomponent.component';
import { SafePipe } from './Pipes/safe.pipe';
import { SWIPER_CONFIG, SwiperConfigInterface, SwiperModule } from 'ngx-swiper-wrapper';
import * as Hammer from 'hammerjs';
import { FormsModule } from '@angular/forms';
import { DynamicgateComponent } from './components/dynamicgate/dynamicgate.component';
import { CookieService } from 'ngx-cookie-service'
import { PnrFlightFormComponent } from './components/pnr-flight-form/pnr-flight-form.component';
import { ServiceWorkerModule, SwRegistrationOptions } from '@angular/service-worker';
import { environment } from '../environments/environment';


const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
  observer: true,
  direction: 'horizontal',
  threshold: 50,
  spaceBetween: 5,
  slidesPerView: 1,
  centeredSlides: true
};

export class MyHammerConfig extends HammerGestureConfig {
  overrides = <any>{
    swipe: { direction: Hammer.DIRECTION_ALL },
  };
}

@NgModule({
  declarations: [AppComponent, AllGatesComponent, PrivacycomponentComponent, SafePipe, DynamicgateComponent],
  imports: [
    BrowserModule, 
    AppRoutingModule, 
    MatDialogModule, 
    MatIconModule, 
    MatCheckboxModule, 
    MatInputModule, 
    MatButtonModule,
    BrowserAnimationsModule, 
    MatDividerModule, 
    MatFormFieldModule, 
    MatSelectModule, 
    MatProgressSpinnerModule,
    SwiperModule,
    FormsModule,
    // ServiceWorkerModule.register('ngsw-worker.js'),
    ServiceWorkerModule.register('push-sw.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the app is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    })
  ],
  providers: [DatePipe, DeviceDetectorService, CookieService,
    // {
    //   provide: SwRegistrationOptions,
    //   useFactory: () => ({ enabled: environment.production }),
    // },
    {
    provide: SWIPER_CONFIG,
    useValue: DEFAULT_SWIPER_CONFIG
  },{
    provide: HAMMER_GESTURE_CONFIG,
    useClass: MyHammerConfig,
  },],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
